import rootPath from "../routes-path";
import { RouteProps as BaseRouteProps } from "../routes-path";
export { RouteProps } from "../routes-path";

export interface DetailRouteProps extends BaseRouteProps {
    prestupId: string;
}

export const path = "/prestupy";

export default rootPath + path;


export const detail = '/detail';
export const detailPath = rootPath + path + detail + '/:prestupId';